import _ from 'lodash'
import React from 'react'
import { PreviewSkeletonType } from 'src/lib/types/uiPreview'
import Pill from './Pill'
import { useLocale } from 'src/lib/hooks/useLocal'
import { hexToRGBA } from 'src/@core/utils/hex-to-rgba'

interface LoadingAddressListProps {
  length?: number
  borderColor: string | undefined
  skeleton: PreviewSkeletonType
  deliveryText: string
  isDeliveryTextEnabled: boolean
  isETDEnabled?: boolean
}

const LoadingAddressList: React.FC<LoadingAddressListProps> = ({
  length = 1,
  borderColor,
  skeleton,
  deliveryText,
  isDeliveryTextEnabled,
  isETDEnabled = false
}) => {
  const { t } = useLocale()
  return (
    <>
      {_.times(length, (index: number) => {
        return (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: '0.75rem',
              width: '100%',
              gap: 16,
              border: `1px solid #f0f0f0`,
              borderRadius: '16px 16px 28px 28px'
            }}
          >
            <div
              style={{
                display: 'flex',
                width: '100%',
                justifyContent: 'space-between'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  gap: 6
                }}
              >
                <Pill height={1} width={1} />
                <Pill height={1} width={4} />
              </div>
              {isDeliveryTextEnabled ? (
                <span className='font-normal text-[#2C874A] leading-4 text-sm'>{deliveryText}</span>
              ) : (
                <></>
              )}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: skeleton.layout,
                alignItems: 'start',
                padding: '0.75rem',
                width: '100%',
                border: `2px solid ${borderColor}`,
                borderRadius: '16px',
                gap: 6
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: skeleton?.config?.[0].layout,
                  gap: 6,
                  justifyContent: skeleton?.config?.[0]?.justify
                }}
              >
                {skeleton?.config?.[0]?.config?.map((item: any, index: number) => {
                  return <Pill height={item?.height} width={item?.width} key={index} />
                })}
              </div>

              {skeleton?.config?.map((item: any, index: number) => {
                return <Pill height={item?.height} width={item?.width} key={index} />
              })}
              {isETDEnabled ? (
                <div
                  style={{ backgroundColor: hexToRGBA(borderColor ?? '#000000', 0.2) }}
                  className='h-[30px] w-full rounded-md flex items-center justify-center mt-2'
                >
                  <p className='text-sm font-medium'>{t('earliest_delivery_sample_text')}</p>
                </div>
              ) : null}
            </div>
          </div>
        )
      })}
    </>
  )
}

export default LoadingAddressList
